<script lang="ts">
    import { createEventDispatcher } from "svelte";

    export let imageUrl: string;

    const dispatch = createEventDispatcher();
    
    export const swipeLeftEvent  = () => {
        dispatch('swipeLeft');
    };
    
    export const swipeRightEvent = () => {
        dispatch('swipeRight');
    };
    
    export const tapEvent = () => {
        dispatch('tap');
    };
    
    export const doubleTapEvent = () => {
        dispatch('doubleTap');
    };

    let touchStartX: number = 0;
    let touchEndX: number = 0;
    let lastTouchEnd: number = 0;
    let hasMoved: boolean = false;
    const swipeThreshold: number = 50; // Seuil de déplacement en pixels
    
    const handleTouchStart = (event: TouchEvent) => {
      touchStartX = event.touches[0].clientX;
    };
    
    const handleTouchMove = (event: TouchEvent) => {
      touchEndX = event.touches[0].clientX;
      hasMoved = true;
    };
    
    const handleTouchEnd = (event: TouchEvent) => {
        
        const deltaX = touchEndX - touchStartX;
        
        if (Math.abs(deltaX) >= swipeThreshold && hasMoved) {
            if (deltaX > 0) {
                swipeLeftEvent();
            } else if (deltaX < 0) {
                swipeRightEvent();
            }
        } else {
            tapEvent();
        }

        touchStartX = 0;
        touchEndX = 0;
        hasMoved = false;
        
        const now = new Date().getTime();
        const elapsedTime = now - lastTouchEnd;
        lastTouchEnd = now;
        
        if (elapsedTime <= 300) { // Délai pour détecter le double tap (300 ms)
            doubleTapEvent();
        }
    };
  </script>

<img
    on:touchstart={handleTouchStart}
    on:touchmove={handleTouchMove}
    on:touchend={handleTouchEnd}
    on:dblclick={doubleTapEvent}
    class="w-full h-full object-contain overflow-hidden"
    src={imageUrl}
    alt="none"
/>
